<template>
  <email-forwarder />
</template>

<script>
import EmailForwarder from '@/components/Services/Hosting/Shared/Email/Forwarders/EmailForwarder'

export default {
  name: 'EmailForwardersView',
  components: {
    EmailForwarder
  }
}
</script>
